import MapIcon from '@mui/icons-material/Map';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import PeopleIcon from '@mui/icons-material/People';
import AccessibleIcon from '@mui/icons-material/Accessible';
import HomeWorkIcon from '@mui/icons-material/HomeWork';

export const menus = [
    {
        title: 'Mapeamento',
        icon: <MapIcon className="menu-icon-sidebar-dashboards" fontSize='large'/>,
        path: '/governanceroom/dashboardunifiedregistry/mapping',
        gap: true
    },
    {
        title: 'Familias',
        icon: <FamilyRestroomIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardunifiedregistry/families',
    },
    {
        title: 'Pessoas',
        icon: <PeopleIcon className="menu-icon-sidebar-dashboards" fontSize='large'/>,
        path: '/governanceroom/dashboardunifiedregistry/people',
    },
    {
        title: 'Deficiência',
        icon: <AccessibleIcon className="menu-icon-sidebar-dashboards" fontSize='large'/>,
        path: '/governanceroom/dashboardunifiedregistry/disability',
    },
    {
        title: 'Situação de Rua',
        icon: <HomeWorkIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardunifiedregistry/street-situation',
    },
]